const medium = '@media (max-width: 1024px)'
const mediumLarge = '@media (max-width: 1120px)'
const large = '@media (max-width: 1279px)'
const xLarge = '@media (max-width: 1920px)'

const mediaQuery = {
  medium,
  mediumLarge,
  large,
  xLarge,
} as const

export default mediaQuery
